module.exports = __webpack_public_path__ + "img/marker1.fcf30153.png";